import createAction from "redux-actions/lib/createAction";

// GetUserAll;
export const GET_USERS_ALL = "GET_USERS_ALL";
export const GetUserAll = createAction(GET_USERS_ALL);

// GetUserById
export const GET_USERS_BY_ID = "GET_USERS_BY_ID";
export const GetUserById = createAction(GET_USERS_BY_ID);

// VerifyUserName
export const VERIFY_USER_NAME = "VERIFY_USER_NAME";
export const VerifyUserName = createAction(VERIFY_USER_NAME);

// Register
export const ACCOUNT_REGISTER = "ACCOUNT_REGISTER";
export const Register = createAction(ACCOUNT_REGISTER);

// RegisterProfile
export const ACCOUNT_REGISTER_PROFILE = "ACCOUNT_REGISTER_PROFILE";
export const RegisterProfile = createAction(ACCOUNT_REGISTER_PROFILE);

// RegisterUserSaga
export const REGISTER_USER_SAGA = "REGISTER_USER_SAGA";
export const RegisterUserSaga = createAction(REGISTER_USER_SAGA);

// UpdateUserSaga
export const UPDATE_USER_SAGA = "UPDATE_USER_SAGA";
export const UpdateUserSaga = createAction(UPDATE_USER_SAGA);

// UpdateUser
export const ACCOUNT_UPDATE_USER = "ACCOUNT_UPDATE_USER";
export const UpdateUser = createAction(ACCOUNT_UPDATE_USER);
export const ACCOUNT_UPDATE_USER_SUCCESS = "ACCOUNT_UPDATE_USER_SUCCESS";
export const UpdateUserSuccess = createAction(ACCOUNT_UPDATE_USER_SUCCESS);

// GeneratePasswordResetToken
export const GENERATE_PASSWORD_RESET_TOKEN = "GENERATE_PASSWORD_RESET_TOKEN";
export const GeneratePasswordResetToken = createAction(GENERATE_PASSWORD_RESET_TOKEN);

// ForgotPassword
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const ForgotPassword = createAction(FORGOT_PASSWORD);

// ChangeUserPassword
export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const ChangeUserPassword = createAction(CHANGE_USER_PASSWORD);

// ChangeUserPasswordToken
export const CHANGE_USER_PASSWORD_TOKEN = "CHANGE_USER_PASSWORD_TOKEN";
export const ChangeUserPasswordToken = createAction(CHANGE_USER_PASSWORD_TOKEN);

// DeleteUser
export const DELETE_USER = "DELETE_USER";
export const DeleteUser = createAction(DELETE_USER);

// GetUserPermissions
export const GET_USER_PERMISSIONS = "GET_USER_PERMISSIONS";
export const GetUserPermissions = createAction(GET_USER_PERMISSIONS);

// AddPermissionsList
export const ADD_PERMISSIONS_LIST = "ADD_PERMISSIONS_LIST";
export const AddPermissionsList = createAction(ADD_PERMISSIONS_LIST);

// DelPermissionsList
export const DELETE_PERMISSIONS_LIST = "DELETE_PERMISSIONS_LIST";
export const DelPermissionsList = createAction(DELETE_PERMISSIONS_LIST);

// GetCurrentUserPermissions
export const GET_CURRENT_USER_PERMISSIONS = "GET_CURRENT_USER_PERMISSIONS";
export const GetCurrentUserPermissions = createAction(GET_CURRENT_USER_PERMISSIONS);
export const GET_CURRENT_USER_PERMISSIONS_SUCCESS = "GET_CURRENT_USER_PERMISSIONS_SUCCESS";
export const GetCurrentUserPermissionsSuccess = createAction(GET_CURRENT_USER_PERMISSIONS_SUCCESS);

// GetCurrentUserDictionary
export const GET_CURRENT_USER_DICTIONARY = "GET_CURRENT_USER_DICTIONARY";
export const GetCurrentUserDictionary = createAction(GET_CURRENT_USER_DICTIONARY);
export const GET_CURRENT_USER_DICTIONARY_SUCCESS = "GET_CURRENT_USER_DICTIONARY_SUCCESS";
export const GetCurrentUserDictionarySuccess = createAction(GET_CURRENT_USER_DICTIONARY_SUCCESS);

// GetChatUserAll
export const GET_CHAT_USER_ALL = "GET_CHAT_USER_ALL";
export const GetChatUserAll = createAction(GET_CHAT_USER_ALL);

// GetUserAndProfilesAll
export const GET_USER_AND_PROFILES_ALL = "GET_USER_AND_PROFILES_ALL";
export const GetUserAndProfilesAll = createAction(GET_USER_AND_PROFILES_ALL);

// GetUserPreferences
export const GET_USER_PREFERENCES = "GET_USER_PREFERENCES";
export const GetUserPreferences = createAction(GET_USER_PREFERENCES);
export const GET_USER_PREFERENCES_SUCCESS = "GET_USER_PREFERENCES_SUCCESS";
export const GetUserPreferencesSuccess = createAction(GET_USER_PREFERENCES_SUCCESS);

// UpdateUserPreferences
export const UPDATE_USER_PREFERENCES = "UPDATE_USER_PREFERENCES";
export const UpdateUserPreferences = createAction(UPDATE_USER_PREFERENCES);
export const UPDATE_USER_PREFERENCES_SUCCESS = "UPDATE_USER_PREFERENCES_SUCCESS";
export const UpdateUserPreferencesSuccess = createAction(UPDATE_USER_PREFERENCES_SUCCESS);